export default class UserInfoActionConst {
  static GET_USERINFO = "GET_USERINFO";
  static UPDATE_USERINFO = "UPDATE_USERINFO";
}
